import { render, staticRenderFns } from "./AxSearchResultModified.vue?vue&type=template&id=0072ac52&"
import script from "./AxSearchResultModified.vue?vue&type=script&lang=ts&"
export * from "./AxSearchResultModified.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports